import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import { Button } from "@material-ui/core"
import { Link as GatsbyLink } from "gatsby"

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  btn: {
    marginRight: theme.spacing(1),
  },
}))

const PageNavigation = ({ previous, next }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {previous && (
        <Button
          to={previous}
          component={GatsbyLink}
          variant="contained"
          color="primary"
          className={classes.btn}
        >
          Back
        </Button>
      )}
      {next && (
        <Button
          to={next}
          component={GatsbyLink}
          color="primary"
          variant="contained"
          className={classes.btn}
        >
          Next
        </Button>
      )}
    </div>
  )
}

PageNavigation.propTypes = {
  previous: PropTypes.string,
  next: PropTypes.string,
}

export default PageNavigation
